export default "__VITE_ASSET__bd2d374b__"